export type StaffRole = 'owner' | 'admin' | 'doctor' | 'tech' | 'receptionist';

const definePermissions = <PermissionTable extends { [permission: string]: StaffRole[] }>(
  table: PermissionTable
): { [Permission in keyof PermissionTable]: StaffRole[] } => table;

export const staffPermissionSchema = definePermissions({
  canOpenExistingAssessment: ['owner', 'admin', 'doctor', 'tech', 'receptionist'],
  canSendQuestionnaires: ['owner', 'admin', 'doctor', 'tech', 'receptionist'],
  canCreateAssessment: ['owner', 'admin', 'doctor', 'tech'],
  canEditAssessment: ['owner', 'admin', 'doctor', 'tech'],
  canLinkQuestionnaire: ['owner', 'admin', 'doctor', 'tech'],
  canViewClinicalNotes: ['owner', 'admin', 'doctor', 'tech'],
  canFinalizeAssessment: ['owner', 'admin', 'doctor'],
  canManageClinicSettings: ['owner', 'admin']
});

export type StaffPermission = keyof typeof staffPermissionSchema;

export type StaffPermissionMap = { [permission in StaffPermission]: boolean };

export function buildPermissions(
  isPermissionGranted: (permission: StaffPermission) => boolean
): StaffPermissionMap {
  const permissions = {} as StaffPermissionMap;
  (Object.keys(staffPermissionSchema) as StaffPermission[]).forEach(permission => {
    permissions[permission] = isPermissionGranted(permission);
  });
  return permissions;
}

export function buildDeniedPermissions(): StaffPermissionMap {
  return buildPermissions(() => false);
}
